import { render } from "./transform.vue?vue&type=template&id=01582ba0"
import script from "./transform.vue?vue&type=script&lang=js"
export * from "./transform.vue?vue&type=script&lang=js"

import "./transform.vue?vue&type=style&index=0&id=01582ba0&lang=css"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__